import { useEffect, useContext } from 'react'
import { useAnalyticsError } from '@/hooks/AnalyticsErrorHook'
import Container from './Container'
import router from 'next/router'
import { Description, Flex, NotFoundImage } from './NotFoundPageTemplate.styles'
import { Spacing, Heading, Button } from '@big-red-group/storefront-common-ui'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'

const ErrorPage = () => {
  const errorOccurred = useAnalyticsError()
  const errorMessage = 'Oops something went wrong'

  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)

  useEffect(() => {
    errorOccurred({ name: 'Error Page', message: errorMessage }, true)
  }, [errorOccurred])

  return (
    <>
      <style jsx global>
        {`
          body {
            background-color: black;
          }
        `}
      </style>
      <Container style={{ backgroundColor: 'black' }}>
        <Flex>
          <div>
            {/* TODO title sparkle */}
            <Heading size="XL" style={{ color: 'white' }}>
              Whoops! Something went wrong
            </Heading>
            <Description>
              But no worries you can still explore thousands of epic Aussie & NZ experiences right here.
            </Description>
            <Button onClick={() => router.push(`${baseUrl}/en`)} style={{ marginTop: '40px' }}>
              Find an experience
            </Button>
            <Spacing size="S" />
            <Button onClick={() => router.push(`${baseUrl}/en/order/checkout`)} style={{ marginTop: '40px' }}>
              View cart
            </Button>
          </div>
          <NotFoundImage src={`${baseUrl}/404.png`} alt="Something went wrong" />
        </Flex>
      </Container>
    </>
  )
}

export default ErrorPage
